import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Event manager portal layout.
 *
 * Only users with role === 'event' see the event management navigation.
 * Event managers can create race events and upload associated documents
 * (Notice of Race, Sailing Instructions, Amendments, etc.).
 */
const EventLayout: React.FC = () => {
  const { user, loading: authLoading } = useAuth();

  if (authLoading) {
    return (
      <div className="event-loading" data-testid="event-loading">
        <p>Loading event portal…</p>
      </div>
    );
  }

  if (!user || user.role !== 'event') {
    return (
      <div className="event-access-denied" data-testid="event-access-denied">
        <h1>Access Denied</h1>
        <p>You do not have permission to access the event management portal.</p>
      </div>
    );
  }

  return (
    <div className="admin-layout" data-testid="event-layout">
      <nav className="admin-nav" data-testid="event-nav">
        <h2>Event Management</h2>
        <ul>
          <li>
            <NavLink to="/events/race-events" data-testid="event-nav-race-events">
              Race Events
            </NavLink>
          </li>
          <li>
            <NavLink to="/events/global-documents" data-testid="event-nav-global-documents">
              Event Documents
            </NavLink>
          </li>
        </ul>
      </nav>
      <div className="admin-content" data-testid="event-content">
        <Outlet />
      </div>
    </div>
  );
};

export default EventLayout;
